import React from 'react';
import { node, bool, func } from 'prop-types';
import useStyles from '../hooks/useStyles';
import Button from './button/Button';

ErrorView.propTypes = {
	title: node,
	message: node,
	showRefresh: bool,
	onClickRefresh: func
};

ErrorView.defaultProps = {
	title: 'Oops, something went wrong',
	message: 'Our team have been notified of the issue, in the meantime a page refresh may help.',
	showRefresh: true,
	onClickRefresh: () => location.reload()
};

export default function ErrorView({ title, message, showRefresh, onClickRefresh }) {
	const classes = useStyles(styles);

	return (
		<div css={classes.container}>
			<h1 css={classes.title}>{title}</h1>
			<p css={classes.message}>{message}</p>
			<div>{showRefresh && <Button onClick={onClickRefresh}>Click here to refresh</Button>}</div>
		</div>
	);
}

function styles({ css }) {
	return {
		container: css`
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			flex-direction: column;
		`,
		title: css`
			margin-bottom: 16px;
		`,
		message: css`
			margin-bottom: 42px;
		`
	};
}
